import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EmpresaComponent }    from './empresa.component';

const SECURITY_ROUTES: Routes = [
  { path: 'security/empresa', component: EmpresaComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(SECURITY_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class EmpresaRoutingModule {}
